import apiClient from './apiClient'
import { HELP_CONTENT_RESOLVE } from './apiEndpoints'
import type { ApiEnvelope } from '@/types/api'
import type { ResolvedHelpContent } from '@/types/help.types'

/**
 * Resolves DB-driven help content for a field, optionally scoped to the currently
 * selected dropdown value (sent as dropdownValueCode — the option string itself,
 * since form dropdowns don't carry a ref_master numeric id on the frontend).
 * Returns null when no help content is configured (backend responds 204).
 */
export async function resolveHelpContent(
  fieldKey: string,
  dropdownValueCode?: string,
  signal?: AbortSignal,
): Promise<ResolvedHelpContent | null> {
  const { data, status } = await apiClient.get<ApiEnvelope<ResolvedHelpContent>>(HELP_CONTENT_RESOLVE, {
    params: { fieldKey, dropdownValueCode: dropdownValueCode || undefined },
    signal,
    validateStatus: (s) => s === 200 || s === 204,
  })

  if (status === 204) return null
  return data.data
}
